<template lang="pug">
md-dialog#general-form-wrapper(:md-click-outside-to-close='false', :ref='dialogRef')
    md-dialog-actions
        md-button.md-primary.closeBtn(@click='closeDialog') X
    div.md-headline

        div(v-if="localExpiredObj.expiredDistribution && localExpiredObj.expiredDistribution.length > 0")
            h4.title Distribution expired
            div.details.header
                p Name
                p Expiration date
            div(v-for="item in localExpiredObj.expiredDistribution")
                a.redirect.info(target="_blank", rel="noopener noreferrer", :href='`distribution/${item._id}/edit`')
                    div.details
                        div.justifyStart
                            strong {{ item.name }}
                        div.justifyStart
                            span.redColor {{ item.endDate.substring(0,10) }}

        div(v-if="localExpiredObj.expiredDistribution && localExpiredObj.deadLineDistribution.length > 0")
            h4.title Distribution near to expiration
            div.details.header
                p Name
                p Expiration date
            div(v-for="item in localExpiredObj.deadLineDistribution")
                a.redirect.info(target="_blank", rel="noopener noreferrer", :href='`distribution/${item._id}/edit`') 
                    div.details
                        div.justifyStart
                            strong {{ item.name }}
                        div.justifyStart
                            span.orangeColor {{ item.endDate.substring(0,10) }}

        div(v-if="localExpiredObj.expiredDistribution && localExpiredObj.expiredLisenses.length > 0")
            h4.title Licenses expired
            div.details.header
                p Name
                p Expiration date
            div(v-for="item in localExpiredObj.expiredLisenses")
                a.redirect.info(target="_blank", rel="noopener noreferrer", :href='`license/${item._id}`') 
                    div.details
                        div.justifyStart
                            strong {{ item.name }}
                        div.justifyStart
                            span.redColor {{ item.endDate.substring(0,10) }}

        div(v-if="localExpiredObj.expiredDistribution && localExpiredObj.deadLineLisenses.length > 0")
            h4.title Licenses near to expiration
            div.details.header
                p Name
                p Expiration date
            div(v-for="item in localExpiredObj.deadLineLisenses")
                a.redirect.info(target="_blank", rel="noopener noreferrer", :href='`license/${item._id}`') 
                    div.details
                        div.justifyStart
                            strong {{ item.name }}
                        div.justifyStart
                            span.orangeColor {{ item.endDate.substring(0,10) }}
</template>

<script>
import uuid from 'uuid';
import Loader from '../../shared-components/Loader';

export default {
    components: {
        Loader
    },
    props: {
        expiredObj: {},
    },
    data() {
        return {
            dialogRef: uuid.v4(),
            localExpiredObj: {},
        };
    },
    methods: {
        closeDialog() {
            const ref = this.dialogRef;
            this.$refs[ref].close();
            this.$emit('closed');
        },
        openDialog(expired) {
            const ref = this.dialogRef;
            this.localExpiredObj = expired;
            this.$refs[ref].open();
        },
    }
};
</script>

<style lang="scss" scoped>

.closeBtn:hover{
    transform: scale(1.3);
}

.md-headline {
    height: 55vh;
    overflow-y: auto;
}

.title{
    background-color: #94ccd957;
    margin-inline: 10px;
    border-radius: 6px;
    padding: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    color: rgba(1, 1, 1, .7);
    font-style: italic;
}
.info {
    font-size: 16px;
    margin-top: 10px;
    margin-left: 8px;
}

.redirect{
    display: block;
    padding: 5px;
    margin: 10px;
    margin-right: 20px;
    text-decoration: none;
    color: rgb(58, 57, 57) !important;
    transition: all 400ms;
}
.redirect:hover{
    margin-left: 1%;
    margin-right: 1%;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 600;
    background-color: #94ccd936;
    text-decoration: none !important;
}

.header{
    color: #464848c1;
    margin-inline: 15px;
}
.details{
    display: flex;
    justify-content: space-between;
}

.redColor{
    color: red;
}

.orangeColor{
    color: orange;
}

</style>


// WEBPACK FOOTER //
// src/spa/marketplace/expiredDistributionDialog.vue